/* Loads checkout integrations with fail-safe click interceptor to prevent dead buttons */
(function () {
  'use strict';

  var loaded = {};

  function loadModule(key, src, attributes) {
    if (loaded[key]) return loaded[key];

    loaded[key] = new Promise(function (resolve, reject) {
      var existing = document.getElementById(key);
      if (existing) {
        resolve(existing);
        return;
      }

      var script = document.createElement('script');
      script.id = key;
      script.type = 'module';
      script.src = src;
      script.async = true;
      Object.keys(attributes || {}).forEach(function (name) {
        script.setAttribute(name, attributes[name]);
      });
      script.addEventListener('load', function () { resolve(script); }, { once: true });
      script.addEventListener('error', function () { reject(new Error('Unable to load ' + key)); }, { once: true });
      document.head.appendChild(script);
    });

    return loaded[key];
  }

  function loadBreeze() {
    return loadModule('breeze-script-tag', 'https://sdk.breeze.in/electron/241.0.3/index.js', {
      'data-environment': 'release',
      'data-platform': 'shopify',
      'data-enable-external-trackers': 'false',
      'data-enable-snap-tracker': 'false',
      'data-enable-ga': 'false',
      'data-enable-fbp': 'false',
      'data-emit-tracker-events': 'true',
      'data-ga4-measurement-id': 'G-H0JTXJRGG5',
      'data-gaVersion': 'new',
      'ghost-mode': 'false',
      'data-merchantid': 'budli'
    });
  }

  function loadForklift() {
    return loadModule('breeze-cart-script', 'https://sdk.breeze.in/forklift/6.0.1/app.js', {
      'data-access-token': '934f4f1e47b5b4efcf21072b6ab1d441'
    });
  }

  function loadSnapmint() {
    if (loaded.snapmint) return loaded.snapmint;
    loaded.snapmint = new Promise(function (resolve, reject) {
      var existing = document.getElementById('snapmint-script');
      if (existing) {
        resolve(existing);
        return;
      }

      var script = document.createElement('script');
      script.id = 'snapmint-script';
      script.src = 'https://checkout-merchant.snapmint.com/js/v1/6273';
      script.async = true;
      script.addEventListener('load', function () { resolve(script); }, { once: true });
      script.addEventListener('error', function () { reject(new Error('Unable to load Snapmint')); }, { once: true });
      document.body.appendChild(script);
    });
    return loaded.snapmint;
  }

  function whenIdle(callback, timeout) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: timeout });
    } else {
      window.setTimeout(callback, timeout);
    }
  }

  function isBreezeReady(el) {
    if (typeof window.customElements === 'undefined') return false;
    if (!window.customElements.get('breeze-button')) return false;
    if (el && el.shadowRoot && el.shadowRoot.querySelector('button, [role="button"], .button, .breeze-btn')) {
      return true;
    }
    return false;
  }

  function getSelectedQuantity(form) {
    var formId = form && form.id;
    var input = null;
    if (form) {
      input = form.querySelector('input[name="quantity"]');
    }
    if (!input && formId) {
      input = document.querySelector('input[name="quantity"][form="' + formId + '"]');
    }
    if (!input) {
      input = document.querySelector('.quantity__input, input[name="quantity"]');
    }
    if (input) {
      var val = parseInt(input.value, 10);
      if (!isNaN(val) && val > 0) return val;
    }
    return 1;
  }

  function getSelectedVariantId(form) {
    var formId = form && form.id;
    var input = null;
    if (form) {
      input = form.querySelector('[name="id"]');
    }
    if (!input && formId) {
      input = document.querySelector('[name="id"][form="' + formId + '"]');
    }
    if (!input) {
      input = document.querySelector('input[name="id"], select[name="id"]');
    }
    return input ? input.value : null;
  }

  function fallbackCheckout() {
    var form = document.querySelector('form[action*="/cart/add"], .product-form');
    var variantId = getSelectedVariantId(form);
    var quantity = getSelectedQuantity(form);

    if (variantId) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      }).then(function (res) {
        if (!res.ok) throw new Error('Cart add failed');
        window.location.href = '/checkout';
      }).catch(function () {
        if (form) {
          form.submit();
        } else {
          window.location.href = '/checkout';
        }
      });
    } else if (form) {
      form.submit();
    }
  }

  function installClickGuardian(btn) {
    if (!btn) return;

    // Track state to prevent race conditions, dual checkouts, & double taps
    // States: 'idle' | 'loading_breeze' | 'breeze_ready' | 'fallback_active'
    var guardianState = 'idle';
    var fallbackTimer = null;

    btn.addEventListener('click', function (e) {
      // If Breeze is already loaded and ready, let Breeze handle the click natively
      if (guardianState === 'breeze_ready' || isBreezeReady(btn)) {
        guardianState = 'breeze_ready';
        return;
      }

      // If fallback checkout was already triggered or in progress, block duplicate clicks
      if (guardianState === 'fallback_active' || guardianState === 'loading_breeze') {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      // First early tap before Breeze is ready: intercept
      guardianState = 'loading_breeze';
      e.preventDefault();
      e.stopImmediatePropagation();

      // Show immediate tactile feedback so the user knows their tap registered
      btn.style.opacity = '0.7';
      btn.style.cursor = 'wait';

      fallbackTimer = setTimeout(function () {
        if (guardianState !== 'loading_breeze') return;
        guardianState = 'fallback_active';
        btn.style.opacity = '1';
        btn.style.cursor = '';
        fallbackCheckout();
      }, 2200);

      loadBreeze().then(function () {
        if (typeof window.customElements !== 'undefined') {
          window.customElements.whenDefined('breeze-button').then(function () {
            // CRITICAL RACE CHECK: If fallback has already fired (e.g. after 2.2s), DO NOT replay click into Breeze!
            if (guardianState !== 'loading_breeze') {
              return;
            }

            clearTimeout(fallbackTimer);
            guardianState = 'breeze_ready';
            btn.style.opacity = '1';
            btn.style.cursor = '';

            // Replay click into Breeze shadowRoot button
            setTimeout(function () {
              var inner = btn.shadowRoot && btn.shadowRoot.querySelector('button, [role="button"], .breeze-btn, .button');
              if (inner && !inner.disabled) {
                inner.click();
              } else {
                btn.click();
              }
            }, 60);
          });
        }
      }).catch(function () {
        if (guardianState !== 'loading_breeze') return;
        guardianState = 'fallback_active';
        clearTimeout(fallbackTimer);
        btn.style.opacity = '1';
        btn.style.cursor = '';
        fallbackCheckout();
      });
    }, true); // Capture phase ensures we intercept before custom element handles it
  }

  function addIntentListeners(element, callback) {
    if (!element) return;
    ['pointerenter', 'focusin', 'touchstart', 'pointerdown'].forEach(function (eventName) {
      element.addEventListener(eventName, callback, { once: true, passive: true });
    });
  }

  function primeProductCheckout() {
    var buyNow = document.getElementById('breezePrimary');
    var stickyBuy = document.getElementById('budliStickyBuy');
    var productForm = document.querySelector('.product-form');

    function loadAllCheckoutApps() {
      loadBreeze();
      loadForklift();
      loadSnapmint();
    }

    // Install early click guardian on Buy Now button to eliminate dead taps
    installClickGuardian(buyNow);

    // 1. Direct user intent: hover, focus, touch on buy buttons or product form
    addIntentListeners(buyNow, loadAllCheckoutApps);
    addIntentListeners(stickyBuy, loadAllCheckoutApps);
    addIntentListeners(productForm, loadAllCheckoutApps);

    // 2. Load during idle on product pages (800ms) so it is ready before user taps
    whenIdle(loadAllCheckoutApps, 800);

    // 3. Proximity trigger as viewport scrolls near purchase area
    var target = buyNow || productForm;
    if (target && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            loadAllCheckoutApps();
            observer.disconnect();
          }
        });
      }, { rootMargin: '300px 0px' });
      observer.observe(target);
    }
  }

  function init() {
    var isProduct = document.body.classList.contains('template-product');
    var isCart = document.body.classList.contains('template-cart');

    if (isProduct) {
      primeProductCheckout();
      return;
    }

    if (isCart) {
      whenIdle(function () {
        loadBreeze();
        loadForklift();
        loadSnapmint();
      }, 600);
      return;
    }

    // Non-product pages (Collections, Home): load cart script on cart link interaction or deep idle
    var cartLinks = document.querySelectorAll('a[href="/cart"], #cart-icon-bubble, .cart-icon');
    cartLinks.forEach(function (el) {
      addIntentListeners(el, loadForklift);
    });
    whenIdle(loadForklift, 3500);
  }

  window.BudliCheckout = {
    loadBreeze: loadBreeze,
    loadForklift: loadForklift,
    loadSnapmint: loadSnapmint,
    isBreezeReady: isBreezeReady
  };

  document.addEventListener('DOMContentLoaded', init, { once: true });
})();
